import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import member from './member/reducers'
import profile from './profile/reducers'
import device from './device/reducers'
import clinic from './clinic/reducers'
import notifications from './notifications/reducers'
import clinicPatient from './clinicPatient/reducers'
import liveRespiration from './liveRespiration/reducers'
import alertSubscription from './alertSubscription/reducers'
import billingEligibility from './billingEligibility/reducers'
import dashboard from './dashboard/reducers'
import report from './report/reducers'
import billing from './billing/reducers'
import medicalGroup from './medicalGroup/reducers'

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    menu,
    device,
    user,
    settings,
    member,
    profile,
    clinic,
    notifications,
    clinicPatient,
    liveRespiration,
    alertSubscription,
    billingEligibility,
    dashboard,
    report,
    billing,
    medicalGroup,
  })
